package com.appcreator.blueprint.actions

import com.appcreator.blueprint.core.Action
import com.appcreator.blueprint.core.ActionClass
import com.appcreator.blueprint.core.InputProperty
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("ReviewPromptAction")
@ActionClass(
    group = "Other",
    title = "Review Prompt Action",
    availableFrom = "0.0.1"
)
class ReviewPromptAction(
    @InputProperty(
        title = "Show on attempt",
        description = "Number of time this action needs to be triggered before the review prompt will actually show",
        availableFrom = "0.0.1"
    )
    val showOnAttempt: Int?,
    @InputProperty(
        title = "Attempt Frequency Days",
        description = "Number of days between last asking before trying again, shouldn't be less than 7",
        availableFrom = "0.0.1"
    )
    val attemptFrequency: Int?
): Action
